import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '../typography';

var styles = function styles(_ref) {
  var _horizontalContent;

  var breakpoints = _ref.breakpoints,
      palette = _ref.palette,
      spacing = _ref.spacing,
      mixins = _ref.mixins;
  return {
    horizontalContent: (_horizontalContent = {
      marginBottom: -1
    }, _defineProperty(_horizontalContent, breakpoints.up('sm'), {
      borderLeft: "1px solid ".concat(palette.divider)
    }), _defineProperty(_horizontalContent, breakpoints.down('xs'), {
      borderTop: "1px solid ".concat(palette.divider)
    }), _horizontalContent),
    verticalContent: {
      marginBottom: -1,
      borderTop: "1px solid ".concat(palette.divider)
    },
    verticalControl: _objectSpread({}, mixins.flex('flex-start', 'center'), _defineProperty({
      flexDirection: 'column',
      marginTop: spacing(2)
    }, breakpoints.up('sm'), _objectSpread({}, mixins.flex('center', 'flex-end'), {
      flexDirection: 'row',
      marginTop: 0
    }))),
    horizontalControl: _objectSpread({}, mixins.flex('flex-start'), _defineProperty({
      flexDirection: 'column',
      marginTop: spacing(2)
    }, breakpoints.up('sm'), {
      flexDirection: 'row'
    }))
  };
}; // eslint-disable-next-line prefer-arrow-callback


export var DescriptionCard = React.forwardRef(function DescriptionCard(props, ref) {
  var classes = props.classes,
      children = props.children,
      title = props.title,
      control = props.control,
      description = props.description,
      vertical = props.vertical,
      rest = _objectWithoutProperties(props, ["classes", "children", "title", "control", "description", "vertical"]);

  var titleProps = title && description ? {
    gutterBottom: 'small'
  } : {};
  var titleEl = title && React.createElement(Typography, _extends({
    variant: "titleBig"
  }, titleProps), title);
  var descriptionEl = description && React.createElement(Typography, {
    variant: "bodyLight",
    component: "div"
  }, description);

  if (vertical) {
    return React.createElement(Card, _extends({
      "data-testid": "vertical",
      ref: ref
    }, rest), React.createElement(CardContent, null, React.createElement(Grid, {
      container: true,
      alignItems: "center"
    }, React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 8
    }, titleEl, descriptionEl), control && React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4,
      className: classes.verticalControl,
      "data-testid": "description-card-control"
    }, control))), React.createElement("div", {
      className: classes.verticalContent
    }, children));
  }

  return React.createElement(Card, _extends({
    "data-testid": "horizontal",
    ref: ref
  }, rest), React.createElement(Grid, {
    container: true
  }, React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, React.createElement(CardContent, null, titleEl, descriptionEl, control && React.createElement("div", {
    className: classes.horizontalControl,
    "data-testid": "description-card-control"
  }, control))), React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 8,
    className: classes.horizontalContent
  }, children)));
});
process.env.NODE_ENV !== "production" ? DescriptionCard.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  control: PropTypes.node,
  description: PropTypes.node,
  title: PropTypes.node,
  vertical: PropTypes.bool
} : void 0;
DescriptionCard.defaultProps = {
  title: null,
  control: null,
  description: null,
  vertical: false
};
export default withStyles(styles, {
  name: 'DescriptionCard'
})(DescriptionCard);